import signedFetch from '../util/signedFetch.js';

/**
 * Get Product - External IDs Request
 */
export default () => signedFetch('getExternalIds', `${__API_BASE__}/admin-console/product/external-id`, 'GET');
